module.exports = __webpack_public_path__ + "media/images/btn_search-f165bdf79ab2fdcc8b72b388271fdd90.gif";